import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IPromptRefereeResponse {
  status: boolean;
  message: string;
  data: {
    data: string;
  };
  errors: IApiResponseError[];
}

const initialState: IApiState<IPromptRefereeResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const promptRefereeAsync = createAsyncThunk(
  'promptReferee',
  async (id: string, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;
      const accessToken = state.auth.value?.data?.token?.accessToken;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };
      const { data } = await api.post(
        `/referral/referrer/prompt/${id}`,
        {},
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IPromptRefereeResponse>;
      return rejectWithValue(error.response?.data);
    }
  }
);

export const promptRefereeSlice = createSlice({
  name: 'promptReferee',
  initialState,
  reducers: {
    promptRefereeReset: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(promptRefereeAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(promptRefereeAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IPromptRefereeResponse;
      })
      .addCase(promptRefereeAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IPromptRefereeResponse;
        state.error = action.error.message;
      });
  },
});

export const { promptRefereeReset } = promptRefereeSlice.actions;

export default promptRefereeSlice.reducer;
